module.exports = __webpack_public_path__ + "img/advance.ffd7f84.png";